//
// 姓名変更画面
//

document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName('entry-name-page')
  if (pages.length == 0) return

  // 全角・半角の空白除去
  const stripSpace = (name) => {
    return name.replace(/[\u{20}\u{3000}]/gu, '')
  }

  // フルネームと姓・名の不一致判定
  const isRenamed = (fullName, familyName, givenName) => {
    const strippedFullName = stripSpace(fullName)
    const easternNameOrder = stripSpace(familyName + givenName)
    const westernNameOrder = stripSpace(givenName + familyName)

    return ![easternNameOrder, westernNameOrder].includes(strippedFullName)
  };

  // 確認ダイアログ表示
  const submitButton = document.getElementsByClassName('btn')[0]
  submitButton.addEventListener('click', (e) => {
    const fullName = document.getElementById('full-name').value
    const givenName = document.getElementById('given-name').value
    const familyName = document.getElementById('family-name').value

    const confirmMessage = '名刺に記載されている氏名と一致しません。\n更新してもよろしいですか？'

    if (isRenamed(fullName, givenName, familyName) && !confirm(confirmMessage)) {
      e.preventDefault()
      return false
    }
  })
})
